<template>
    <div>
<div >
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-btn  class="success" v-bind="attrs" v-on="on" >
              <v-icon left>mdi-plus</v-icon>
              <span>Novo feriado</span>
          </v-btn>

    
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Novo Feriado
        </v-card-title>

        <v-div >
           <v-form class="pa-5" ref="form">
               
            
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >

                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date"
                    label="Dia do feriado"
                    prepend-icon="fa fa-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                   
                    required
                ></v-text-field>
                </template>
                
                <v-date-picker
                locale="pt-br"               
                v-model="date"
                :min="new Date(Date.now() - 86400000).toISOString().substr(0, 10)"
                @change="save"
                ></v-date-picker>

              
            </v-menu>

               
                <v-select
                    v-model="item.barbeiros"
                     item-text="nome"
                     item-value="id"
                    :items="barbeiros"
                    chips
                    label="Selecione barbeiros"
                    multiple
                    solo
                ></v-select>
           </v-form>
        </v-div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-2" @click="criarNovoItem">
            Criar
          </v-btn>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
    </div>
</template>

<script>
import { refBarbeiros, refFeriados} from '@/firebaseConfig'
    export default {
      props: ['acaoEditar', 'itemPassado'],

        data(){
            return {
               
                disabled: false,
                dbRef: refBarbeiros,
                refFeriados: refFeriados,
                dialog: false,
                date: null,
                menu: false,
                barbeiros: [],
                item: {},
                 inputRules: [
                    v => v.length >= 3  || "Tamanho mínimo é 3 caractéres" 
                ],

            }
        },
        
    
    methods: {
      checarCampos(){
        return  typeof this.item.nome === 'undefined' || this.item.nome === ''
      //  ||  typeof this.item.nascimento === 'undefined' || this.item.nascimento === ''
      },
      save (date) {
        this.$refs.menu.save(date)
      },
      criarNovoItem(){
            if(this.$refs.form.validate()){
                console.log("registrar")
                this.item.data = this.date;
                this.item.dataQuery = new Date(this.date).getTime();
                
                let barbeiros = [];
                //montar objeto dos barbeiros dentro dos feriados
                this.item.barbeiros.map((idB)=>{
                    this.barbeiros.map((barb) => {
                        if(idB == barb.id){
                            barbeiros.push(barb)
                        }
                    })
                });
                this.item.barbeiros = barbeiros
                
                this.refFeriados.add(this.item).then(ref => {
                    console.log(ref);
                    //this.barbeiro.id = ref.id;
                    
                    //ref.set(this.barbeiro);
                    //this.dbRef.doc(ref.id).update(this.barbeiro);
                    ref.update({id:ref.id });
                    this.$emit('recarregarLista');

                })
                this.$refs.form.reset()
            }

            this.dialog = false

      },
        carregarBarbeiros(){[
            this.dbRef.get().then((snap) => {
                snap.forEach((doc)=> {
                    this.barbeiros.push(doc.data())
                });
            })
        ]} 
    
    },
    created() {
        this.carregarBarbeiros()
      //this.ajustarPagina()
    }
    }
</script>

<style lang="scss" scoped>

</style>